import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { buttons, icons } from 'seal-ui-components';
import store from '@Store';
import { NOTIFICATION_HANDLER } from '@Constants/types';
import { isCurrentSystemExpired, checkSSO } from '@Actions/authentication';
import SystemMenuPanel from './components/SystemMenuPanel';
import {
    StatusDot,
    SystemItemLabelWrapper,
    SystemItemLabel,
    SystemItemActionMenu
} from './SystemItem.style';

export const SystemItem = props => {
    const {
        id,
        index,
        checked,
        OnSystemClick,
        label,
        removeSystem,
        editSealSystem,
        selectedSystemId,
        AuthSectionState,
        toggleAuthType,
        friendlyName,
        sealUrl,
        username: principal,
        sealSystems,
        logout
    } = props;

    const [option, setOption] = useState({
        id,
        section: '',
        visible: false
    });
    const [systemName, setSystemName] = useState(label);
    const [disableLoginButton, setDisableLoginButton] = useState(false);

    const { isAuthenticated } = useSelector(state => state.auth);

    useEffect(
        () => {
            setOption(() => ({ ...option, section: AuthSectionState }));
        },
        [AuthSectionState]
    );

    useEffect(
        () => {
            setSystemName(label);
        },
        [label]
    );

    const ItemClickHandler = () => {
        OnSystemClick(id);
    };

    const cropSystemName = () => {
        let temp = systemName;
        if (temp.length > 22) temp = `${temp.slice(0, 22)}..`;
        setSystemName(temp);
    };

    const unCropSystemName = () => {
        setSystemName(label);
    };

    const loginOnClickHandler = () => {
        store.dispatch({ type: NOTIFICATION_HANDLER.DISMISS_ERROR });
        if (sealUrl) {
            checkSSO(sealUrl);
        }
        if (selectedSystemId !== id) {
            if (!isCurrentSystemExpired(id)) {
                setDisableLoginButton(true);
                setTimeout(() => setDisableLoginButton(false), 3000);
                return ItemClickHandler();
            }
            ItemClickHandler();
        }
        if (
            option.section.toLowerCase() === 'sso' ||
            option.section.toLowerCase() === 'credentials'
        ) {
            ItemClickHandler();

            if (option.visible === true)
                return setOption(() => ({ ...option, section: AuthSectionState, visible: false }));
        }

        return setOption(() => ({ ...option, section: AuthSectionState, visible: true }));
    };

    const EditOnClickHandler = () => {
        if (option.section === 'EDIT')
            if (option.visible === true)
                return setOption(() => ({
                    ...option,
                    visible: false
                }));
        return setOption(() => ({ ...option, section: 'EDIT', visible: true }));
    };

    const DeleteOnClickHandler = () => {
        if (option.section === 'DELETE')
            if (option.visible === true)
                return setOption(() => ({
                    ...option,
                    visible: false
                }));
        return setOption(() => ({ ...option, section: 'DELETE', visible: true }));
    };

    /**
     * Why add + before styled-comp props to change boolean to number using "unary plus operator"
     * refer to this link https://maximeblanc.fr/blog/how-to-fix-the-received-true-for-a-non-boolean-attribute-error
     */

    return (
        <>
            <SystemItemLabelWrapper
                onMouseEnter={() => cropSystemName()}
                onMouseLeave={() => unCropSystemName()}
                section={option.section}
                visible={+option.visible}
                checked={checked}
                key={`${id}-system-item`}
                id={id}
                authenticated={+isAuthenticated}
                data-testid={`system_${index}`}
                className="system-item-container"
            >
                <StatusDot
                    id={`system_status_${index}`}
                    authenticated={+isAuthenticated}
                    checked={checked}
                />
                <SystemItemLabel
                    id={`system_name_${index}`}
                    data-tip={systemName}
                    data-place="bottom"
                    data-for={`systemTooltip_${index}`}
                >
                    {systemName}
                </SystemItemLabel>
                <SystemItemActionMenu className="action-menu">
                    {isAuthenticated && checked ? (
                        <buttons.Button
                            id={`system_logout_${index}`}
                            appearance="primary"
                            size="medium"
                            section={option.section}
                            onClick={() => logout(true, principal)}
                        >
                            Logout
                        </buttons.Button>
                    ) : (
                        <buttons.Button
                            id={`system_logout_${index}`}
                            appearance="primary"
                            size="medium"
                            disabled={disableLoginButton}
                            section={option.section}
                            onClick={() => loginOnClickHandler()}
                        >
                            {disableLoginButton ? 'Logging in' : 'Login'}
                        </buttons.Button>
                    )}
                    <buttons.IconButton
                        id={`system_edit_${index}`}
                        className="edit"
                        onClick={() => EditOnClickHandler()}
                        size="medium"
                        icon={<icons.EditSmallIcon />}
                    />
                    <buttons.IconButton
                        id={`system_delete_${index}`}
                        name="button--delete"
                        onClick={() => DeleteOnClickHandler()}
                        size="medium"
                        icon={<icons.DeleteSmallIcon />}
                    />
                </SystemItemActionMenu>
            </SystemItemLabelWrapper>
            <SystemMenuPanel
                id={id}
                label={label}
                index={index}
                checked={checked}
                option={option}
                setOption={setOption}
                principal={principal}
                editSealSystem={editSealSystem}
                removeSystem={removeSystem}
                friendlyName={friendlyName}
                sealSystems={sealSystems}
                sealUrl={sealUrl}
                selectedSystemId={selectedSystemId}
                toggleAuthType={toggleAuthType}
                isAuthenticated={isAuthenticated}
            />
        </>
    );
};

export default SystemItem;
